import { connect } from 'react-redux'
import React from 'react'
import { Switch, Router,Route,Redirect } from 'react-static'

import { listenForAuthStatusChanges } from '../actions/account'
import { listenForOrdersChanges } from '../actions/orders'
import { listenForProductsChanges } from '../actions/products'
import { listenForClientsChanges } from '../actions/clients'

import LayoutRoute from '../components/LayoutRoute'

import Home from './Home'
import SignIn from './SignIn'
import SignUp from './SignUp'
import Account from './Account'
import About from './About'
import SignOut from './SignOut'
import ForgotPassword from './ForgotPassword'
import ShowOrder from './ShowOrder'
import ShowClient from './ShowClient'
import ShowProduct from './ShowProduct'
import NewOrder from './NewOrder'
import NewClient from './NewClient'
import NewProduct from './NewProduct'
import ShowInvoice from './ShowInvoice'
import Orders from './Orders'
import Clients from './Clients'
import Products from './Products'
import Statistics from './Statistics'
import NotFound from './404'

class AppRouter extends React.Component {
  // start listening
  start = (funcName) => {
    if(!this[`stopCallback_${funcName}`]) {
      this[`stopCallback_${funcName}`] = this.props[funcName]()
    }
  }
  // stop listening
  stop = (funcName) => {
    if(this[`stopCallback_${funcName}`]) {
      this[`stopCallback_${funcName}`]()
      this[`stopCallback_${funcName}`] = null
    }
  }

  componentDidMount(){
    this.start('listenForAuthStatusChanges')
  }

  componentDidUpdate(prevProps) {
    if(!prevProps.currentAccountId && this.props.currentAccountId) {
      this.start('listenForOrdersChanges')
      this.start('listenForClientsChanges')
      this.start('listenForProductsChanges')
    }
    if(prevProps.currentAccountId && !this.props.currentAccountId) {
      this.stop('listenForOrdersChanges')
      this.stop('listenForClientsChanges')
      this.stop('listenForProductsChanges')
    }
  }

  componentWillUnmount(){
    this.stop('listenForAuthStatusChanges')
    this.stop('listenForOrdersChanges')
    this.stop('listenForClientsChanges')
    this.stop('listenForProductsChanges')
  }

  render(){
    const {authUser, account, isFetching} = this.props
    const props = {authUser, account, isFetching}
    return (
      <Router autoScrollToTop={false}>
        <React.Fragment>
          <Switch>
            {/*}<LayoutRoute layout='dashboard' exact path="/" component={Home} {...props}/>*/}
            <Route exact path='/' render={matchProps => {matchProps.history.replace('/orders'); return null}}/>

            <LayoutRoute authRequired layout='dashboard' path="/orders" component={Orders} {...props}/>
            <LayoutRoute authRequired layout='dashboard' path="/clients" component={Clients} {...props}/>
            <LayoutRoute authRequired layout='dashboard' path="/products" component={Products} {...props}/>
            <LayoutRoute authRequired layout='dashboard' path="/statistics" component={Statistics} {...props}/>
            <LayoutRoute layout='dashboard' exact path="/about" component={About} {...props}/>
            <LayoutRoute authRequired layout='dashboard' exact path="/account" component={Account} {...props}/>
            <LayoutRoute layout='default' exact path="/signin" component={SignIn} {...props}/>
            <LayoutRoute layout='default' exact path="/signup" component={SignUp} {...props}/>

            <LayoutRoute layout='dashboard' exact path="/signout" component={SignOut} {...props}/>
            <LayoutRoute layout='default' exact path="/forgotpw" component={ForgotPassword} {...props}/>

            <LayoutRoute layout='default' exact component={NotFound} />
          </Switch>

          <LayoutRoute authRequired layout='dashboard' exact path='/orders/:id/show' component={ShowOrder} {...props}/>
          <LayoutRoute authRequired layout='dashboard' exact path='/clients/:id/show' component={ShowClient} {...props}/>
          <LayoutRoute authRequired layout='dashboard' exact path='/products/:id/show' component={ShowProduct} {...props}/>
          <LayoutRoute authRequired layout='dashboard' exact path='/orders/:id/invoice'  component={ShowInvoice} {...props}/>
          <LayoutRoute authRequired layout='dashboard' exact path='/orders/new' component={NewOrder} {...props}/>
          <LayoutRoute authRequired layout='dashboard' exact path='/clients/new' component={NewClient} {...props}/>
          <LayoutRoute authRequired layout='dashboard' exact path='/products/new' component={NewProduct} {...props}/>
        </React.Fragment>
      </Router>
    )
  }
}

export default connect(
  state => ({
    authUser: state.account.authUser,
    currentAccountId: state.account.currentAccountId,
    account: state.account.accessibleAccounts.find(a =>
      a.id===state.account.currentAccountId
    ),
    isFetching: state.account.isFetching
  }),
  dispatch => ({
    listenForAuthStatusChanges: () => dispatch(listenForAuthStatusChanges()),
    listenForOrdersChanges: () => dispatch(listenForOrdersChanges()),
    listenForClientsChanges: () => dispatch(listenForClientsChanges()),
    listenForProductsChanges: () => dispatch(listenForProductsChanges())
  })
)(AppRouter)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/PageRouter.js